import heroBanner from "../../assets/images/pages/mature-driver-course.jpg";
import ShellCard from "../../components/ShellCard.jsx";

const MatureDriverCourse = () => {
  return (
    <>
      <section className="hero-slider-section">
        <div
          className="hero-banner"
          style={{
            backgroundImage: `url(${heroBanner})`,
          }}
        >
          <div className="banner-text-container">
            <div className="banner-heading">
              <h1 className="banner-title">Mature Driver Course</h1>
              <p className="banner-subheading">6-Hour Florida DMV Certified</p>
            </div>
          </div>
        </div>
      </section>

      <p className="text-center fs-4 mt-5 mb-0 px-5" style={{ color: "var(--metro-yellow)" }}>
        Over 55? Receive an Insurance Discount TODAY!
      </p>

      <section className="container py-5" style={{ backgroundColor: "#111" }}>
        <div className="row">
          <div className="col-12">
            <ShellCard>
              <div className="row">
                <div className="col-12">
                  <h3 className="mb-4" style={{ color: "var(--metro-yellow)" }}>
                    Course Details
                  </h3>

                  <div className="mb-4">
                    <p className="lh-lg" style={{ color: "#fff" }}>
                      As a Florida Department of Highway Safety and Motor
                      Vehicles (DHSMV) approved provider, we are proud to offer
                      the Coaching the Mature Driver Course. In accordance with
                      Florida Statute 627.0652, if you are over 55 years of age,
                      you're eligible to earn a reduction on your car insurance
                      premiums. By taking the course, you will be able to have a
                      deduction on your rates, which can range from 5%-10%
                      annually depending on your provider, and it will be valid
                      for 3 years. After 3 years, you would be eligible to
                      re-take the course to maintain your insurance rates
                      discount.
                    </p>
                  </div>

                  <div
                    className="p-4 rounded mb-4"
                    style={{
                      backgroundColor: "#333",
                      border: "2px solid var(--metro-yellow)",
                    }}
                  >
                    <h5 className="fw-bold mb-4" style={{ color: "var(--metro-yellow)" }}>
                      Notable Insurance Providers Discounts:
                    </h5>
                    <ul style={{ color: "#fff" }}>
                      <li className="mb-2">
                        <span className="fw-bold">Geico:</span>{" "}
                        <span style={{ color: "var(--metro-yellow)" }}>10%</span>
                      </li>
                      <li className="mb-2">
                        <span className="fw-bold">Allstate:</span>{" "}
                        <span style={{ color: "var(--metro-yellow)" }}>10%</span>
                      </li>
                      <li className="mb-2">
                        <span className="fw-bold">Progressive:</span>{" "}
                        <span style={{ color: "var(--metro-yellow)" }}>5%</span>
                      </li>
                      <li className="mb-2">
                        <span className="fw-bold">State Farm:</span>{" "}
                        <span style={{ color: "var(--metro-yellow)" }}>5%</span>
                      </li>
                    </ul>
                  </div>

                  <div
                    className="text-center"
                    style={{ marginTop: "40px", marginBottom: "16px" }}
                  >
                    <button
                      type="button"
                      className="btn btn-lg px-4 py-3 fw-bold text-dark metro-btn-primary"
                      data-bs-toggle="modal"
                      data-bs-target="#mature-info-modal"
                    >
                      Call to Enroll
                    </button>
                  </div>
                </div>
              </div>
            </ShellCard>
          </div>
        </div>
      </section>

      {/* Enrollment Modal */}
      <div
        className="modal fade"
        id="mature-info-modal"
        tabIndex="-1"
        aria-labelledby="matureInfoLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content bg-dark text-white">
            <div className="modal-header bg-dark border-0">
              <h5 className="modal-title" id="matureInfoLabel">
                Mature Driver Course
              </h5>
              <button
                type="button"
                className="btn-close btn-close-white"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body bg-dark">
              <p className="mb-0">
                To enroll for a class in Palm Beach, Broward or Miami-Dade
                counties
                <br />
                <span className="fw-bold">Please call </span>
                <a
                  href="tel:3055535000"
                  className="fw-bold"
                  style={{ color: "var(--metro-yellow)" }}
                >
                  305-553-5000
                </a>
                .
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default MatureDriverCourse;
